import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';


export default function OneUserAccountInfoComponent({ handleBasicFormChange,handleInnerFormChange, selectedOneUser, accounts }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>



            <InputContainer
              label="Person Account"
              name="IsPersonAccount"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'Account.IsPersonAccount',
                  selectedOneUser?.Account
                )
              }}
              type="checkbox"
              value={selectedOneUser?.Account?.IsPersonAccount}
            />

        
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Account.Name',
                  selectedOneUser?.Account
                )
              }}
              type="text"
              value={selectedOneUser?.Account?.Name}
            />

            <InputContainer
              label="AccountPId"
              name="AccountPId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Account.AccountPId',
                  selectedOneUser?.Account
                )
              }}
              type="number"
              value={selectedOneUser?.Account?.AccountPId}
            />







          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Account Info"
      />

    </>
  )
}